// index.js
import Collection from './Collection';

export default Collection;



// WEBPACK FOOTER //
// ./src/comps/Collection/index.js